<div
    class="bg-[#1a1a1a] text-[#e6e6e6] text-xs w-full z-10 border-solid border-t border-l-0 border-r-0 border-b-0 border-[#333333] shrink-0"
>
    <div
        class="footer text-shs-white-1 text-xs flex items-center gap-2 sm:gap-4 p-1 sm:p-2 border-t border-shs-gray-4 overflow-x-auto"
    >
        <div class="text-xs text-[#e6e6e6] select-none whitespace-nowrap flex-shrink-0 px-2 py-1">
            Siemens Healthineers AG ©{{ year() }}
        </div>
        @for (link of links(); track $index; let last = $last) {
            <a
                class="text-xs text-[#e6e6e6] py-1 px-2 whitespace-nowrap flex-shrink-0 min-h-[32px] sm:min-h-auto flex items-center"
                [href]="link.url"
                target="_blank"
                >{{ `common.footer.${link.name}` | translate }}</a
            >
        }
    </div>
</div>
